/* esm.sh - use-sync-external-store@1.7.0/shim */
export * from "/*use-sync-external-store@1.7.0/esnext/shim.mjs";
export { default } from "/*use-sync-external-store@1.7.0/esnext/shim.mjs";
